import { TChatbotChartVisualization } from '@monorepo/types';

export const AI_ANALYTICS_CHART_MODEL = {
  createModel(data: TChatbotChartVisualization, isMobileScreen: boolean): Highcharts.Options {
    return {
      chart: {
        type: getHighchartsType(data.type),
      },
      title: {
        text: data.title,
      },
      subtitle: {
        text: data.description,
      },
      xAxis:
        data.type === 'pie'
          ? undefined
          : {
              categories: data.data.labels,
              title: {
                text: data.x_axis,
              },
              labels: {
                style: { fontSize: '11px' },
              },
            },
      yAxis:
        data.type === 'pie'
          ? undefined
          : {
              title: {
                text: data.y_axis,
              },
            },
      tooltip: {
        pointFormat: data.type === 'pie' ? '<b>{point.percentage:.1f}%</b> ({point.y})' : '<b>{point.y}</b>',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          },
        },
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        column: {
          dataLabels: {
            enabled: true,
          },
        },
        scatter: {
          marker: {
            radius: 5,
          },
        },
      },
      series: getSeries(data),
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: !isMobileScreen,
        fallbackToExportServer: false,
      },
    };
  },
};

function getHighchartsType(type: string): Highcharts.SeriesOptionsType['type'] | undefined {
  const map: Record<string, Highcharts.SeriesOptionsType['type']> = {
    bar: 'bar',
    pie: 'pie',
    line: 'line',
    scatter: 'scatter',
    histogram: 'column',
  };
  return map[type];
}

function getSeries(data: TChatbotChartVisualization): Highcharts.SeriesOptionsType[] {
  const {
    type,
    data: { labels, values },
    y_axis,
  } = data;

  switch (type) {
    case 'pie':
      return [
        {
          type: 'pie',
          name: y_axis,
          data: labels.map((label, i) => ({
            name: label,
            y: values[i],
          })),
        },
      ];
    case 'scatter':
      return [
        {
          type: 'scatter',
          name: y_axis,
          data: values.map((y, i) => [i, y]),
        },
      ];
    case 'line':
      return [
        {
          type: 'line',
          name: y_axis,
          data: values,
        },
      ];
    case 'bar':
      return [
        {
          type: 'bar',
          name: y_axis,
          data: values,
        },
      ];
    case 'histogram':
      return [
        {
          type: 'column',
          name: y_axis,
          data: values,
        },
      ];
    default:
      return [];
  }
}
